<div class="welcome"></div>

<div class="whiteBoxWrapper">
  <div class="container" style="position: relative">
    <h2 *ngIf="!selectedIndex$">Momentan ist kein Pitch am Laufen.</h2>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedIndex$ | async" (selectedTabChange)="selectCycleByIndex($event)">
      <mat-tab class="pitch-tab" *ngFor="let cycle of cycles$ | async" [label]="cycle.name" [attr.data-cycle]="cycle" autofocus>
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    </mat-tab-group>
    <ng-template #tabContent>
      <div class="whiteBox row" style="margin: 0">
        <div class="leftPane pitch col-s-12 col-lg-4">
          <ng-container *ngIf="product$ | async as product">
            <ng-container *ngIf="selectedCycle$ | async as cycle">
              <ng-container *ngIf="selectedApplication$ | async as application">
                <app-status-panel [cycle]="cycle" [application]="application" (applyCycle)="openPublish(product.id)"></app-status-panel>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div class="middlePane col-s-12 col-lg-4">
          <h2 class="dashboard-box-header" style="text-align: center">Dein Bewerbungsstatus</h2>
          <app-steps-panel [application]="selectedApplication$ | async"></app-steps-panel>
        </div>

        <div class="rightPane col-s-12 col-lg-4">
          <!-- *ngFor ensures that app-votes-panel is re-created upon changes of application or product -->
          <ng-container *ngIf="selectedVotes$ | async as votes">
            <app-votes-panel [votes]="votes"></app-votes-panel>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div class="section tutorial font">
  <div class="container">
    <h2 id="tutorialHeader">So gehts</h2>

    <div class="video row">
      <div class="col-sm-12 col-md-6 videoWrapper">
        <video playsinline controls width="100%" poster="./assets/img/video-poster.png" controls>
          <source src="https://voila-blob.frc.prod.markhub.markant.services/static/Explainer_new.webm" type="video/webm" />
          <source src="https://voila-blob.frc.prod.markhub.markant.services/static/Explainer_new.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="col-sm-12 col-md-6 videoTextWrapper" style="text-align: left">
        <p style="margin-top: 0">
          Du hast die Idee, wir die Kontakte! Mit voilà! hast Du die Chance auf einen exklusiven Pitch vor Entscheidern der größten Markant-Händler. Diese
          Händler stehen für einen Umsatz von über 55 Milliarden Euro und über 6.500 Verkaufsstellen.
        </p>

        <p>Klingt gut, aber Du willst noch mehr?</p>

        <p>
          Kein Problem! Hinter voilà! stehen insgesamt über 200 Händler aus dem gesamten Verbund der Markant Gruppe, denen Du dich und Deine Ideen zudem online
          präsentieren kannst. So gewinnst Du zusätzlich schnell, einfach und vor allem kostenlos Reichweite, Bekanntheit und Aufmerksamkeit im größten
          Händler-Netzwerk in Deutschland und ganz Europa.
        </p>

        <p>voilà! ist Dein Tor zum Handel! Lass dir diese einzigartige Chance nicht entgehen!</p>
      </div>
    </div>
  </div>
</div>

<div id="jury" class="section jury font">
  <app-jury-section></app-jury-section>
</div>

<div class="faqs section font">
  <div class="container" id="faqContainer">
    <h2 id="faqHeader">FAQs</h2>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header> Wer kann sich bewerben? </mat-expansion-panel-header>
        <div class="faqText">
          Jedes Start-up mit einem innovativen Produkt kann sich über die voilà!-Website registrieren und bewerben. Unsere Empfehlung:
          <ul>
            <li>Dein Produkt sollte verkehrsfähig sein.</li>
            <li>Du solltest dir bereits Gedanken über Skalierungsmöglichkeiten gemacht haben.</li>
            <li>Dein Produkt sollte noch nicht in der Markant Gruppe breit distribuiert sein.</li>
          </ul>
          Pro Start-up ist nur ein User zulässig.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Wie oft kann ich mich bewerben? </mat-expansion-panel-header>
        <div class="faqText">
          Wenn es mit einer Bewerbung nicht sofort klappt, kannst Du Dich bis zu fünfmal mit demselben Produkt bewerben. Sobald Du einmal für den Pitch
          ausgewählt wurdest, kannst Du Dich mit Deinem Unternehmen nicht erneut bewerben – auch nicht mit einem anderen Produkt.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Mit wie vielen Produkten kann ich mich für einen Pitch bewerben? </mat-expansion-panel-header>
        <div class="faqText">
          Du kannst Dich mit einem Produkt oder einer Produktrange bewerben. Verweise auf weitere Produkte sind im Text oder Pitch Deck erlaubt.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Wann erfahre ich, ob ich pitchen darf? </mat-expansion-panel-header>
        <div class="faqText">
          Den aktuellen Stand Deiner Bewerbung siehst Du im Login-Bereich auf der Startseite in Deinem Dashboard. Spätestens drei Wochen vor dem jeweiligen
          Pitch erhältst Du eine Rückmeldung, ob Du einer der ausgewählten Teilnehmer bist.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Wie läuft der Auswahlprozess ab? </mat-expansion-panel-header>
        <div class="faqText">
          Nachdem Du Dich erfolgreich registriert, Deine persönliche Produktseite angelegt und deine Bewerbung abgeschickt hast, prüfen wir diese auf
          Vollständigkeit und Eignung. Nach erfolgreicher Prüfung schlagen wir Dich den Händlern zur Auswahl vor.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Was ist, wenn ich einen Termin doch nicht wahrnehmen kann? </mat-expansion-panel-header>
        <div class="faqText">
          Das wäre schade! Bitte gib uns in diesem Fall aber schnellstmöglich Bescheid, damit wir einem anderen Start-up die Chance geben können. Gerne kannst
          Du Dich dann für einen alternativen Termin bewerben.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Was erwarten die Handelspartner? </mat-expansion-panel-header>
        <div class="faqText">
          Bei unseren Handelspartnern stichst Du heraus, wenn Du ein einzigartiges Produkt kreativ und überzeugend präsentierst. Unsere Tipps:
          <ul>
            <li>Bewirb Dich mit Deinem stärksten Artikel.</li>
            <li>Verwende aussagekräftige Bilder.</li>
            <li>Hebe Dein Alleinstellungsmerkmal hervor.</li>
            <li>Passe deine Bewerbung auf die Struktur der Händler an.</li>
            <li>Hab gute Argumente parat: Wie unterscheidest Du Dich von Wettbewerbern? Wo platzierst Du Dein Produkt im Regal?</li>
            <li>Der Pitch sollte auf das Listungsgespräch vorbereiten – es ist kein Investorenpitch.</li>
          </ul>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Wie geht es weiter, wenn ich keine Einladung bekommen habe? </mat-expansion-panel-header>
        <div class="faqText">
          Sollte Deine Bewerbung nicht erfolgreich gewesen sein, kannst Du Dich erneut für einen anderen Termin bewerben. Außerdem kannst Du Dich auf dem
          Markant Handelsforum (<a target="_blank" rel="noopener" href="https://handelsforum.markant.com/de/">mehr Infos hier</a>) allen unseren Handelspartnern
          an Deinem eigenen Stand präsentieren. Dies bietet Dir die Möglichkeit, alle Handelspartner an einem Ort zu treffen und persönlich von Dir zu
          überzeugen. Wir beraten Dich gerne unter <a href="mailto:startups@de.markant.com" class="faqLink">startups&#64;de.markant.com</a>.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Ist voilà! - die Start-up-Arena kostenfrei? </mat-expansion-panel-header>
        <div class="faqText">
          Die Bewerbung, der Pitch und die Möglichkeit, sich den Markant Handelspartnern zu präsentieren, ist kostenfrei. Wenn der Pitch im Rahmen des Markant
          Handelsforums stattfindet, dann ist auch der 9-m²-Messestand auf der Start-up-Fläche für dich kostenfrei.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Brauche ich für die Bewerbung und den Pitch einen Markant Vertrag? </mat-expansion-panel-header>
        <div class="faqText">
          Zum Zeitpunkt Deiner Bewerbung und des Pitchs benötigst Du noch keinen Markant Vertrag. Erst, wenn Du eine Geschäftsbeziehung mit einem unserer
          Handelspartner eingehen möchtest, wird ein Markant Vertrag obligatorisch. Es gibt keine Grundgebühr, sondern es fällt eine prozentuale Kondition pro
          eingereichtem Beleg an. Bei weiteren Fragen hierzu stehen wir Dir gerne unter
          <a href="mailto:startups@de.markant.com" class="faqLink">startups&#64;de.markant.com</a> zur Verfügung.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header> Welche Vorteile bietet ein Markant Vertrag für Start-ups? </mat-expansion-panel-header>
        <div class="faqText">
          Der Markant Vertrag erleichtert Dir und den Handelspartnern die Zusammenarbeit, z. B. in der Beleg- und Zahlungsabwicklung. Du erhältst außerdem
          Zugang zu allen unseren etablierten Dienstleistungen. Diese bieten Dir Preisvorteile, unterstützen Dich in der Prozessoptimierung und ermöglichen Dir
          die Vernetzung in unserem Händlernetzwerk. Wenn Du jetzt noch Fragen hast, schreib uns unter
          <a href="mailto:startups@de.markant.com" class="faqLink">startups&#64;de.markant.com</a>.
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="contacts section">
  <div class="container font">
    <h2 id="teamHeader">Das voilà! Team</h2>
    <br />
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <img src="./assets/img/voila-team.webp" style="max-width: 100%" alt="Voila Team" />
        <div id="teamPictureDescription">
          Wir sind das Team hinter voilà! – die Start-up-Arena:<br />
          Alicia, Isabel, Jessica und Jaqueline (v. l. n. r.)
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        {{ this.dasTeamText }}
        <strong><a href="mailto:startups@de.markant.com"> startups&#64;de.markant.com</a> </strong>
        <br />
      </div>
    </div>
  </div>
</div>
